import { forEach, pick } from 'lodash';
import * as blobUtil from 'blob-util';
import EncodingOptions from 'media-platform-js-sdk/src/dto/video/encoding-options';
import { TYPE_IMAGE, TYPE_VIDEO } from './request-credentials';

const DEFAULT_ENCODING_OPTIONS = new EncodingOptions()
  .setVideoFormats(['mp4', 'webm'])
  .setAudioFormat('m4a')
  .toFormParams();

const IMAGE_PROPERTIES = ['width', 'height', 'file_name', 'original_file_name'];

export { TYPE_IMAGE, TYPE_VIDEO };
export default function uploadFile({ file, name, type, credentials: { uploadToken, uploadUrl } }) {
  const formData = new FormData();

  let blob = file;
  try {
    blob = blobUtil.dataURLToBlob(blob);
  } catch (e) {}
  formData.append('file', blob, name);
  formData.append('media_type', type);
  formData.append('upload_token', uploadToken);
  if (type === TYPE_VIDEO) {
    forEach(DEFAULT_ENCODING_OPTIONS, (value, key) => formData.append(key, value));
  }

  const request = new XMLHttpRequest();
  const promise = new Promise((resolve, reject) => {
    try {
      request.responseType = 'json'; // IE11 does not support responseType json
    } catch (error) {}
    request.addEventListener('load', event => {
      let data = event.target.response[0];
      try {
        data = JSON.parse(event.target.response)[0];
      } catch (error) {}

      if (type === TYPE_IMAGE) {
        data = pick(data, IMAGE_PROPERTIES);
      }

      resolve(data);
    });
    request.addEventListener('error', reject);
    request.open('POST', uploadUrl);
    request.send(formData);
  });

  return {
    xhr: request,
    promise,
  };
}
